import React from 'react';
import { Button } from 'reactstrap';

const TermosButton = () => {
  return <Button color="link" className="termos-button">Termos de uso > </Button>
}

export default TermosButton;